import { Avatar, theme } from 'antd'
import { TbBriefcase, TbBuilding, TbSitemap } from 'react-icons/tb'

import { initials } from '@/Ship/Helpers/fieldViews'
import { classNames } from '@/Ship/Helpers/classNames'

import type { DiskUserRef } from '../Contracts/DiskNode'
import type { DiskPrincipalType } from '../Contracts/DiskShare'
import type { ReactNode } from 'react'

import styles from './DiskShare.module.css'

const ICON: Record<Exclude<DiskPrincipalType, 'user'>, ReactNode> = {
    department: <TbSitemap />,
    role: <TbBriefcase />,
    company: <TbBuilding />,
}

/** Що за адресат — підписом, для читачів екрана. */
export const PRINCIPAL_KIND: Record<DiskPrincipalType, string> = {
    user: 'Співробітник',
    department: 'Відділ',
    role: 'Роль',
    company: 'Уся компанія',
}

/**
 * Аватар адресата доступу: людина — фото чи ініціали (як Ship `UserChip`),
 * відділ, роль і компанія — іконка виду.
 */
export const DiskPrincipalAvatar = ({
    type,
    user,
    title,
    size = 32,
}: {
    type: DiskPrincipalType
    user: DiskUserRef | null
    title: string
    size?: number
}) => {
    const { token } = theme.useToken()

    if (type === 'user') {
        const photo = user?.photoUrl

        return (
            <Avatar
                size={size}
                {...(photo ? { src: photo, alt: title } : {})}
                style={{
                    background: token.colorPrimaryBg,
                    color: token.colorPrimary,
                    fontSize: Math.max(9, Math.round(size * 0.42)),
                    flexShrink: 0,
                }}
            >
                {initials(title)}
            </Avatar>
        )
    }

    return (
        <span
            className={classNames(styles['avatar'])}
            style={{ width: size, height: size }}
            role="img"
            aria-label={PRINCIPAL_KIND[type]}
        >
            {ICON[type]}
        </span>
    )
}
